/*
 * @Description:
 * @version: 1.0.0
 * @Author: youqixin
 * @Date: 2022-01-05 15:16:57
 * @LastEditors: youqixin
 * @LastEditTime: 2022-01-05 16:25:38
 */
export const navigatorTo = function (path) {
  const currentPath = window.location.href;
  for (let i = 0, len = otherRoutes.length; i < len; i++) {
    const item = otherRoutes[i];
    if (path.indexOf(`/${item}`) > -1 && currentPath.indexOf(`/${item}`) > -1) {
      this.$router.push(path.replace(`/${item}`, ""));
      console.log(path);
      break;
    } else if (
      path.indexOf(`/${item}`) === -1 &&
      currentPath.indexOf(`/${item}`) === -1
    ) {
      this.$router.push(path.replace(`/${item}`, ""));
    } else {
      window.location.href = path;
    }
  }
  // if (path.indexOf("/xcrm") > -1 && currentPath.indexOf("/xcrm") > -1) {
  //   this.$router.push(path.replace("/xcrm", ""));
  // } else if (
  //   path.indexOf("/xcrm") === -1 &&
  //   currentPath.indexOf("/xcrm") === -1
  // ) {
  //   this.$router.push(path.replace("/xcrm", ""));
  // } else {
  //   window.location.href = path;
  // }
};

export const otherRoutes = ["xhshop", "xcrm"];
